// extracted by mini-css-extract-plugin
module.exports = {"YoutubeButton":"YoutubeButton_YoutubeButton__2LnzG","Link":"YoutubeButton_Link__1DLig"};